import { render } from "./fines.vue?vue&type=template&id=127e197d"
import script from "./fines.vue?vue&type=script&lang=js"
export * from "./fines.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__